import { useLocation } from 'react-router-dom';
import { useAppBreakpoint } from '@/contexts/BreakpointContext';
import { useTableScrollBudget } from '@/contexts/TableScrollBudgetContext';
import { isMainLayoutFixedTableScrollPath } from './mainFixedTableScrollPaths';
import { isWorkspaceFixedTableScrollPath } from './workspaceFixedTableScrollPaths';

/**
 * 视口 + 路由白名单是否允许尝试固定表体布局（不含实测预算）。
 * `useTableScrollY` 在 eligible 为 true 时持续探测预算并写入 Context。
 */
export function useTableScrollYLayoutEligible() {
    const { viewportAllowsTableScrollYLayout } = useAppBreakpoint();
    const { pathname } = useLocation();
    if (!viewportAllowsTableScrollYLayout) return false;
    return isMainLayoutFixedTableScrollPath(pathname) || isWorkspaceFixedTableScrollPath(pathname);
}

/**
 * 是否与 MainLayout / WorkspaceLayout 中 **`data-table-scroll-layout="fixed"`** 及 Card **`overflow: hidden`** 锁链一致、允许为 Table 写 **`scroll.y`**。
 *
 * 仅当同时满足：
 * 1. **`useTableScrollYLayoutEligible()`**：视口够高且 pathname 在白名单；
 * 2. **`budgetAllowsFixedLayout !== false`**：列表页 hook 实测表体预算 ≥ `TABLE_BODY_SCROLL_MIN`（未测量前为 `null`，先按 fixed 探测）。
 *
 * 列表页应 **`enabled: useEnableTableScrollYLayout()`**（并可 **`|| isFullscreen`** 等）传入 **`useTableScrollY`**，与本文返回值保持一致；勿在视口不足或非白名单页单独把 **`enabled`** 固定为 **true**。
 */
export function useEnableTableScrollYLayout() {
    const eligible = useTableScrollYLayoutEligible();
    const { budgetAllowsFixedLayout } = useTableScrollBudget();
    if (!eligible) return false;
    return budgetAllowsFixedLayout !== false;
}
